module.exports = __webpack_public_path__ + "static/media/20210212_214607_377_IMG_2181.b2cd8357.jpg";